import { createContext } from 'react';

const TaskContext = createContext({
    isNew: true,
    lockedState: true,
    isSaveButtonTriggered: false,
    /** @type {string} */
    taskId: null,
    /** @type {import('@dyl/constants/Skills').Skill} */
    skill: null,
    /** @type {import('@dyl/task-types/createTaskType').TaskType<any>} */
    taskType: null,
    /** @type {unknown} */
    data: null,
    /** @param {React.SetStateAction<unknown>} next */
    setData(next) { throw new Error('No TaskContext in tree.'); },
    /** @param {React.SetStateAction<boolean>} next */
    setLockedState(next) {
    throw new Error('No TaskContext in tree.');
    },
    /** @param {React.SetStateAction<boolean>} next */
    setIsSaveButtonTriggered(next) {
    throw new Error('No TaskContext in tree.');
    },
    /**
     * @type {{
     *  key: string
     *  message: string
     *  path: (string | number)[]
     * }[]}
     */
    apiValidationErrorData: [],

    /**
     * @param {string} message
     * @returns {() => void} unsubscribe
     */
    registerLocalError(message) { throw new Error('No TaskContext in tree.'); },
});

export default TaskContext;